module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/GwIzss/images/cover.jpg?1684255541785",
      "alt": "This image is the cover for the book Edisto Island, 1663 to 1860, Definitive History"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Edisto Island, 1663 to 1860, Definitive History\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("Wild Eden"), _c('i', [_vm._v(" to "), _c('i', [_vm._v("Cotton Aristocracy"), _c('i', [_vm._v(" is an impeccably researched and superbly written must-read for all whose hearts call Edisto home.")])])])])])]), _c('br'), _c('p', [_vm._v("Beautiful Edisto Island has not always been a vacationers' haven in the South Carolina "), _c('i', [_vm._v("Lowcountry")]), _vm._v(". Before European settlement, it was home to the Edisto Indians, who had seasonal fishing camps in the area, and a wide variety of wildlife. By the beginning of the "), _c('i', [_vm._v("Civil War")]), _vm._v(", the wealthy planters had largely abandoned the area. What happened between those two periods is a must-read for fans of coastal South Carolina.")]), _c('p', [_vm._v("Author Charles Spencer chronicles Edisto's history, from the early days when English and Scottish planters and their African slaves settled the lush island paradise and established plantations that flourished until the Civil War.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Charles Spencer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Charles Spencer is the sole proprietor of Intercultural Tours of Washington, DC, which specializes in tailored tours of the capital for international visitors sponsored by the U.S. Department of State. He holds a bachelor's degree in English from Clemson University and a master's and Ph.D. in Political Science from Vanderbilt University. He has taught at The Citadel, Vanderbilt, and Fisk University and was a Foreign Service Officer from 1966 to 1991.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0